import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useNavigate, useParams } from 'react-router-dom'

import PrimaryButton from '@components/inputs/button/primaryButton'
import SubText from '@components/text/subText'

import colors from '@settings/styleSettings'

import {
  Container, Description, Icon, Title
} from './styles'

const ConcludedFeedback = ({ files }) => {
  const navigate = useNavigate()
  const { insurance } = useParams()

  const handleNavigate = () => {
    window.location = `/${insurance}/acompanhamento`
  }

  useEffect(() => {
    if (!files) {
      navigate(`/${insurance}/acompanhamento/importar-exames`)
    }
  }, [])

  return (
    <Container>
      <Icon className="material-symbols-outlined">check_circle</Icon>
      <Title>Importação concluída !</Title>
      {files > 0 && (
        <SubText>
          Entre os
          {' '}
          {files}
          {' '}
          arquivos carregados,
          {' '}
          {files}
          {' '}
          foram importados com
          sucesso no sistema
        </SubText>
      )}
      <PrimaryButton
        onClick={handleNavigate}
        style={{ margin: 12, width: '230px', float: 'right' }}
      >
        <span
          className="material-symbols-outlined"
          style={{
            color: colors.titleStrongWhite,
            float: 'left',
            marginRight: 8,
          }}
        >
          home
        </span>
        Voltar à página inicial
      </PrimaryButton>
      <Description>
        É importante que os dados do beneficiário estejam corretos para que
        ocorra a importação bem sucedida de um arquivo, caso contrário nosso bot
        não poderá analisá-lo corretamente
      </Description>
    </Container>
  )
}
export default ConcludedFeedback

ConcludedFeedback.propTypes = {
  files: PropTypes.number,
}

ConcludedFeedback.defaultProps = {
  files: [],
}
